import { useState } from 'react';

import { Collapse } from '@mui/material';

import type { DisplayPolicy } from './_types';
import { ProposedPolicyCardHeader } from './ProposedPolicyCardHeader';
import { ProposedPolicyDetail } from './ProposedPolicyDetail';
import type { AutopilotRecommendation } from '../../../open-api-types/autopilot-types';
import { Divider, tokens, Box } from '@cast/design-system';

type ProposedPolicyCardProps = {
  displayPolicy: DisplayPolicy;
  recommendation: AutopilotRecommendation;
};

export const ProposedPolicyCard = ({
  displayPolicy,
  recommendation,
}: ProposedPolicyCardProps) => {
  const [expanded, setExpanded] = useState(false);
  const { policy } = displayPolicy;
  const policyName = policy.payload.name;

  return (
    <Box
      data-testid={`proposed-policy-card-${policyName}`}
      sx={{
        p: 16,
        '&:not(:last-child)': {
          borderBottom: '1px solid',
          borderBottomColor: tokens.theme.border.structural.neutral,
        },
      }}
    >
      <ProposedPolicyCardHeader
        displayPolicy={displayPolicy}
        expanded={expanded}
        onToggle={() => setExpanded((prev) => !prev)}
      />

      <Collapse in={expanded}>
        <Divider sx={{ mt: 12 }} />
        <ProposedPolicyDetail policy={policy} recommendation={recommendation} />
      </Collapse>
    </Box>
  );
};
